module.exports = __webpack_public_path__ + "img/123456.89751e51.png";